import React from 'react';
import { Select } from 'antd';
import { ValueEditor } from 'react-querybuilder';

// react-querybuilder's native <select>/<select multiple> are cramped and
// hard to scan once a field has more than a handful of facet values. This
// swaps those two editor types for antd's Select (searchable, wider, tag
// chips for multi-select) while leaving every other editor type (text,
// number, checkbox, between, ...) to react-querybuilder's own ValueEditor.
const EligibilityValueEditor = (props) => {
  const { type, value, values, handleOnChange, disabled, title, className } = props;

  if (type === 'select' || type === 'multiselect') {
    const isMulti = type === 'multiselect';
    const options = (values || []).map((v) => ({ value: v.name, label: v.label ?? v.name }));
    return (
      <Select
        mode={isMulti ? 'multiple' : undefined}
        allowClear
        showSearch
        optionFilterProp="label"
        placeholder={isMulti ? 'Select one or more values...' : 'Select a value...'}
        value={isMulti ? (Array.isArray(value) ? value : []) : value || undefined}
        onChange={(next) => handleOnChange(next)}
        options={options}
        disabled={disabled}
        title={title}
        className={['eligibility-value-select', className].filter(Boolean).join(' ')}
        popupClassName="eligibility-value-select-dropdown"
        popupMatchSelectWidth={false}
        // "responsive" measures available width via ResizeObserver to decide
        // how many tags fit -- inside a freshly-opened antd Modal that
        // measurement can land at 0 before layout settles, rendering the
        // closed control blank until a focus/resize forces a remeasure. A
        // fixed cap avoids that measurement dependency entirely.
        maxTagCount={8}
        notFoundContent="No values found"
      />
    );
  }

  return <ValueEditor {...props} />;
};

export default EligibilityValueEditor;
